import { render, staticRenderFns } from "./CompanyFormDetails.vue?vue&type=template&id=7a4e57ca&scoped=true&"
import script from "./CompanyFormDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormDetails.vue?vue&type=style&index=0&id=7a4e57ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e57ca",
  null
  
)

export default component.exports